var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
    ]),
    _c(
      "div",
      { staticClass: "control", class: _vm.controlClass },
      [
        _c("input", {
          staticClass: "input",
          attrs: {
            id: _vm.id,
            name: _vm.name,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            required: _vm.required,
            pattern: _vm.pattern ? _vm.pattern : null,
            type: _vm.type,
            step: _vm.step,
            min: _vm.min,
            max: _vm.max,
            minlength: _vm.minlength,
            maxlength: _vm.maxlength
          },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event)
            },
            change: function($event) {
              return _vm.$emit("change", $event)
            },
            focus: function($event) {
              return _vm.$emit("focus", $event)
            },
            blur: function($event) {
              return _vm.$emit("blur", $event)
            }
          }
        }),
        _vm.leftIcon
          ? _c("b-icon", {
              staticClass: "is-small is-left",
              attrs: { icon: _vm.leftIcon }
            })
          : _vm._e(),
        _vm.rightIcon
          ? _c("b-icon", {
              staticClass: "is-small is-right",
              attrs: { icon: _vm.rightIcon }
            })
          : _vm._e(),
        _vm.errorMessage
          ? _c("p", { staticClass: "help is-danger" }, [
              _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }